import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { color, shadows } = baseVariables;

export const StyledNavigationMenuDesktop = styled.div`
  background: ${color.alert10};
`;

export const StyledMainMenu = styled.ul`
  display: flex;
  align-items: center;
  padding-left: 0;
  list-style: none;
  flex-direction: row;
  margin-bottom: 0;
  .main-menu-item,
  .sub-menu-item {
    display: block;
    cursor: pointer;
    color: ${color.neutral40};
    &:hover {
      color: ${color.base10};
    }
  }
`;

export const StyledMainMenuItem = styled.li`
  position: relative;
  padding: 0 ${toRem(20)};
  align-self: stretch;
  button {
    height: 100%;
  }
  &:first-child {
    padding-left: 0;
    .sub-menu {
      left: 0;
    }
  }
  &:last-child {
    padding-right: 0;
    .sub-menu {
      left: auto;
      right: 0;
    }
  }
  &.active,
  &:hover {
    .main-menu-item {
      border-bottom-color: ${color.base10};
      color: ${color.base10};
    }
  }
  &.selected,
  &:focus,
  &:focus-within {
    .main-menu-item {
      border-bottom-color: ${color.base10};
      color: ${color.base10};
    }
    .sub-menu {
      display: block;
    }
  }
  @media ${baseVariables.mediaQuery.lg} {
    padding: 0 ${toRem(30)};
  }
  .main-menu-item {
    padding: ${toRem(20)} 0 ${toRem(19)};
    border-bottom: ${toRem(2)} solid transparent;
    background-color: transparent;
    &:focus {
      border-bottom-color: ${color.base10};
    }
    &:focus + .sub-menu {
      display: block;
    }
  }
`;

export const StyledSubMenu = styled.ul`
  box-shadow: ${shadows.boxShadowSubsection};
  border-bottom-left-radius: ${toRem(6)};
  border-bottom-right-radius: ${toRem(6)};
  padding-left: 0;
  list-style: none;
  display: none;
  position: absolute;
  background: ${color.alert10};
  z-index: 2;
  left: ${toRem(15)};
  width: ${toRem(317)};
`;

export const StyledSubMenuItem = styled.li`
  padding: ${toRem(18)} ${toRem(13)};
  &:first-child {
    padding-top: ${toRem(36)};
  }
  &:last-child {
    padding-bottom: ${toRem(36)};
  }
  &.selected {
    list-style-type: disc;
    padding-left: 0;
    margin-left: ${toRem(32)};
    &::marker {
      color: ${color.base10};
    }
    a {
      color: ${color.base10};
    }
  }
`;
